const pagetopBtn = document.querySelector('#pagetop-cmn');
if (pagetopBtn) {
  pagetopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}
